import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsProductItem from "./SetsProductItem"
import SettingsForm from './SettingsForm'

class SetsProduct extends SettingsForm {

  modelName = 'product'

  newItem = {
    product_desc: '',
    product_active: 1
  };

  render() {
    if(isEmpty(this.props.products.data)){
      return(<div>Не загружены данные</div>);
    }
    const products = this.props.products.data;
    const { search, sort } = this.props.products;
    const { data, errors } = this.state;

    var fltrProducts = [];
    for(var key in products){
      if(products.hasOwnProperty(key)){
        const active = products[key].product_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + products[key].product_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrProducts.push(products[key]);
        }
      }
    }

    const srtProducts = fltrProducts.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.product_id < b.product_id)
         return sort.asc ? -1 : 1
      if(a.product_id > b.product_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedProducts = srtProducts ? srtProducts.map(product =>
      <SetsProductItem key={product.product_id}
        data={product}
      />
    ) : [];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.product_desc}
              name="product_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </div>
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка направлений</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrProducts.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th onClick={() => {this.handleSort('product_desc')}}>Название</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedProducts}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    products: store.products
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsProduct);



// WEBPACK FOOTER //
// ./src/components/settings/SetsProduct.js